export default {
  message: {
    customerNumbersAssistant: {
      date: {
        title: 'Punten berekenen vanaf datum X',
        warning:
          'Met een geselecteerde datum kunnen hoofdklantnummers niet worden verplaatst!',
      },
      import: {
        openButton: 'Klantnummers importeren',
        loadingModal: 'Modal laden...',
        title: 'Klantnummers importeren uit Excel',
        validateButton: 'Bestand valideren',
        submitButton: 'Naar API verzenden',
        submitButtonLoading: 'Bezig met verzenden...',
        selectWholesalerLabel: 'Groothandel',
        selectGroupLabel: 'Groep',
        selectWholesalerPlaceholder: 'Selecteer groothandel',
        selectGroupPlaceholder: 'Selecteer groep (optioneel)',
        requirementsTitle: 'Bestandsvereisten',
        fileFormatRequirement: 'Alleen Excel-bestand: .xlsx of .xls',
        headerRequirement:
          'Koprij moet zijn: Customer number, Email (kolommen A/B).',
        createdLabel: 'Aangemaakt',
        alreadyExistsLabel: 'Bestaat al',
        success: 'Excel-bestand is geldig.',
        submitSuccess: 'Klantnummers succesvol geïmporteerd.',
        previewTitle: 'Voorbeeld',
        summaryTitle: 'Validatieoverzicht',
        previewCount: '{count} rijen, {pageSize} rijen per pagina.',
        importableCountLabel: 'Kan worden geïmporteerd',
        skippedCountLabel: 'Wordt overgeslagen',
        searchPlaceholder: 'Zoek op rij, klantnummer, e-mail of status',
        confirmImportTitle: 'Import bevestigen',
        confirmImportQuestion: 'Wil je de beschikbare records nu importeren?',
        confirmImportButton: 'Nu importeren',
        filters: {
          all: 'Alles',
          importable: 'Importeerbaar',
          skipped: 'Overgeslagen',
        },
        row: 'Rij',
        customerNumber: 'Klantnummer',
        email: 'E-mail',
        status: 'Status',
        userExists: 'Gebruiker bestaat',
        customerNumberExists: 'Klantnummer bestaat',
        customerNumberExistsForEmail: 'Klantnummer bestaat voor e-mail',
        customerNumberOwnerEmail: 'E-mail van eigenaar van klantnummer',
        conflictsFound: 'Er zijn conflicten gevonden. Los die op voor import.',
        previousPage: 'Vorige',
        nextPage: 'Volgende',
        pageInfo: 'Pagina {current} / {total}',
        progressLabel: 'Voortgang',
        statusLabels: {
          available_for_import: 'Beschikbaar voor import',
          already_linked: 'Al gekoppeld',
          customer_number_linked_to_other_user: 'Klantnummer gekoppeld aan andere gebruiker',
          user_not_found: 'Gebruiker niet gevonden',
          user_not_dealer: 'Gebruiker is geen dealer',
          user_in_other_group: 'Gebruiker zit in andere groep',
        },
        summaryLabels: {
          total_rows: 'Totaal aantal rijen',
          available_for_import: 'Beschikbaar voor import',
          already_linked: 'Al gekoppeld',
          customer_number_linked_to_other_user: 'Gekoppeld aan andere gebruiker',
          user_not_found: 'Gebruiker niet gevonden',
          user_not_dealer: 'Gebruiker is geen dealer',
          user_in_other_group: 'Gebruiker in andere groep',
        },
        errors: {
          wholesalerRequired: 'Groothandel is verplicht.',
          groupRequired: 'Groep is verplicht.',
          fileRequired: 'Excel-bestand is verplicht.',
          emptyWorkbook: 'Excel-werkmap is leeg.',
          invalidHeaders:
            'Bestand moet exact 2 kolommen bevatten: klantnummer en e-mail.',
          emptyRows: 'Bestand bevat geen gegevensrijen.',
          firstTwoColumnsRequired:
            'Rij {row}: eerste en tweede kolom moeten ingevuld zijn.',
          invalidCustomerNumber:
            'Ongeldig klantnummer in rij {row}. Gebruik alleen letters en cijfers.',
          invalidEmail: 'Ongeldig e-mailadres in rij {row}.',
          invalidFileType: 'Alleen Excel-bestanden (.xlsx, .xls) zijn toegestaan.',
          readError: 'Kon Excel-bestand niet lezen.',
          validateFirst: 'Valideer eerst het bestand.',
          conflictsBeforeImport: 'Import is geblokkeerd vanwege validatieconflicten.',
          nothingToImport: 'Er zijn geen records beschikbaar om te importeren.',
          submitFailed: 'Verzenden van records naar API mislukt.',
        },
      },
    },
  },
}
